import { Box, useTheme, Grid } from '@mui/material';
import { sxStyle } from './styles';
import LocalizationWithLabel from './LocalizationWithLabel';
import ItineraryText from '@FlightsComponents/ItineraryText';

import { findScale } from '@shared/helpers/flights/flights';

const FlightItineraryLine = ({ option }) => {
  const theme = useTheme();

  if (option.flights.length < 1) return null;

  return (
    <Box sx={sxStyle.container}>
      <LocalizationWithLabel label={option.origin_city} />

      {/* Línea con puntos */}
      <Box id="box-line-section" sx={sxStyle.lineSection}>
        <Box
          sx={{
            ...sxStyle.dashedLine,
            borderTop: `3px dashed ${theme.primary}`,
          }}
        >
          <Grid
            container
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
            }}
          >
            {option.flights.map((x, i) =>
              i === 0 ? null : (
                <Grid
                  item
                  key={x?.flight_number ?? i}
                  sx={sxStyle.point(x.is_stop, theme.primary)}
                />
              )
            )}
          </Grid>
        </Box>

        {/* Texto de escalas encima de la línea */}
        <Box sx={sxStyle.pointsContainer}>
          <ItineraryText sx={{ textAlign: 'center', fontWeight: 600 }}>
            {findScale(option)}
          </ItineraryText>
        </Box>
      </Box>

      <LocalizationWithLabel label={option.destination_city} />
    </Box>
  );
};

export default FlightItineraryLine;
